// extracted by mini-css-extract-plugin
export default {"FormWidth":"form_FormWidth__-5ooH","footerText":"form_footerText__x4m0u"};